import type { AssetDetails } from '../../rxdb/assetDetails/assetDetails.types';
import type { AssetsByAreaHeirachy } from '../../rxdb/assetsByAreaHeirachy/assetsByAreaHierarchy.types';
import { InspectionFiles } from '../../rxdb/inspectionFiles/queryBuilder';
import { InspectionList } from '../../rxdb/inspectionList/queryBuilder';
import { PreviousReportFiles } from '../../rxdb/previousReports/queryBuilder';
import { Discipline } from '../../utilities/enums';

export const mockAssetDetails: AssetDetails = {
  assetId: '2997',
  assetName: 'Dispatch 03-29-(9-HANGER)',
  comment: 'testing comment',
  assetCategoryId: 9,
  assetCategoryName: 'Utilities, Hangers and Supports',
  namePcsId: 'Dispatch 03-29-(9-HANGER)',
  dateCreated: '2021-11-16T11:04:01.6053886+00:00',
  site: 2,
  discipline: 3,
  assetDynamicProperty: [
    {
      id: 2599,
      assetId: 2997,
      assetPropertyDefinitionId: 61,
      name: 'Structure Type',
      value: 'Glulam Arch',
      assetPropertyValue: 'Glulam Arch',
      assetPropertyDefinitionValue: 'test',
      dateCreated: '2016-08-04T11:03:14.5569360-06:00',
      dateModified: '2022-04-05T07:27:08.3636021+00:00',
    },
    {
      id: 2591,
      assetId: 2997,
      assetPropertyDefinitionId: 62,
      name: 'other property3',
      value: 'other property3',
      assetPropertyValue: 'other prop ',
      assetPropertyDefinitionValue: 'test',
      dateCreated: '2016-08-04T11:03:14.5569360-06:00',
      dateModified: '2022-04-05T07:27:08.3636021+00:00',
    },
    {
      id: 2592,
      assetId: 2997,
      assetPropertyDefinitionId: 63,
      name: 'other property2',
      value: 'other property2',
      assetPropertyValue: 'other prop ',
      assetPropertyDefinitionValue: 'test',
      dateCreated: '2016-08-04T11:03:14.5569360-06:00',
      dateModified: '2022-04-05T07:27:08.3636021+00:00',
    },
    {
      id: 2593,
      assetId: 2997,
      assetPropertyDefinitionId: 64,
      name: 'other property1',
      value: 'other property1',
      assetPropertyValue: 'other prop ',
      assetPropertyDefinitionValue: 'test',
      dateCreated: '2016-08-04T11:03:14.5569360-06:00',
      dateModified: '2022-04-05T07:27:08.3636021+00:00',
    },
    {
      id: 2593,
      assetId: 2997,
      assetPropertyDefinitionId: 64,
      name: 'other property1',
      value: 'other property1',
      assetPropertyValue: 'other prop ',
      assetPropertyDefinitionValue: 'test',
      dateCreated: '2016-08-04T11:03:14.5569360-06:00',
      dateModified: '2022-04-05T07:27:08.3636021+00:00',
    },
    {
      id: 2593,
      assetId: 2997,
      assetPropertyDefinitionId: 64,
      name: 'other property1',
      value: 'other property1',
      assetPropertyValue: 'other prop ',
      assetPropertyDefinitionValue: 'test',
      dateCreated: '2016-08-04T11:03:14.5569360-06:00',
      dateModified: '2022-04-05T07:27:08.3636021+00:00',
    },
  ],
  assetMainCategoryName: 'Structural steel',
  eAMAssetId: 0,
  eAMAssetName: 'eamAresId',
  assetDescription: 'description',
  installationDate: '2021-11-16',
  dateModified: '',
  assetFiles: [
    {
      fileId: 1,
      assetId: 2997,
      drawingType: 11,
      fileName: '/Test1',
      path: 'jest/file1',
      site: 2,
      discipline: 3,
    },
    {
      fileId: 2,
      assetId: 2997,
      drawingType: 12,
      fileName: 'Test2',
      path: 'jest/file2',
      site: 2,
      discipline: 3,
    },
    {
      fileId: 3,
      assetId: 2997,
      drawingType: 13,
      fileName: 'Test3',
      path: 'jest/file3',
      site: 2,
      discipline: 3,
    },
    {
      fileId: 4,
      assetId: 2997,
      drawingType: 14,
      fileName: 'Test4',
      path: 'jest/file4',
      site: 2,
      discipline: 3,
    },
  ],
  parentArea: 'parentArea',
  areaType: 'sub Area',
  floorLevel: 0,
  lowerBound: '',
  upperBound: '',
  temperature: '',
  corrosion: '',
  humidity: '',
  waterMake: '',
  floorMovement: '',
  backMovement: '',
  sideWallMovement: '',
  aimsAssetID: '',
  aimsAssetName: 'aimsAssetName',
  eAMAreaId: 'ress',
  etapFields: [
    {
      etapId: 1,
      assetId: '2997',
      etapAssetId: 'test etapAssetId',
      totalEnergy: 1,
      workingDistance: '1',
      afb: '1',
      kv: '1',
      site: 2,
      discipline: 3,
      dateCreated: '',
      dateModified: '',
    },
  ],
};

export const mockAssetDetailsElectrical: AssetDetails = {
  ...mockAssetDetails,
  discipline: Discipline.Electrical,
};

export const mockAssetDetailsShaft: AssetDetails = {
  ...mockAssetDetails,
  discipline: Discipline.Shaft,
};

export const mockInspectionListForAssetDetails: InspectionList = {
  assetId: 2997,
  assetName: 'Dispatch 03-29-(9-HANGER)',
  assetDescription: 'test description',
  inspectionId: '61088',
  assetInspectionType: 'Level 0',
  assetInspectionStatusId: 2,
  assetInspectionStatus: 'InProcess',
  site: 2,
  discipline: 3,
  workPackageId: 3191,
  inspectorId: 496,
  dateCreated: '2021-11-16T11:04:01.6053886+00:00',
  dateModified: '2023-04-14T05:24:04.7586281+00:00',
  isLIstampingRequired: false,
  inspectionAssignmentComment: 'test inspection comment.',
  areaList: [
    {
      assetId: '2997',
      id: '8385',
      name: '03-29',
      type: 2,
      trafficSafety: 9,
      areaName: '03-29 (Dispatch)',
    },
  ],
  areaId: 0,
};

export const mockInspectionListElectricalForAssetDetails: InspectionList = {
  ...mockInspectionListForAssetDetails,
  discipline: Discipline.Electrical,
};

export const mockInspectionListShaftForAssetDetails: InspectionList = {
  ...mockInspectionListForAssetDetails,
  discipline: Discipline.Shaft,
  areaId: 8385,
};

export const mockPreviousReportForAssetDetails: PreviousReportFiles = {
  pkAssetInspection: '12677',
  fkAsset: 2997,
  site: 2,
  discipline: 3,
  originalPath: 'Cory/Structural/Inspections/Dispatch 03-29-(9-HANGER)_General_2020-07-14_7068.pdf',
  inspectionType: 'General',
  assetName: 'Dispatch 03-29-(9-HANGER)',
  dateCompleted: '2020-07-14T00:00:00.000-06:00',
  dateCreated: '2021-02-01T16:22:01.8556412+05:30',
  dateModified: '',
};

export const mockInspectionFilesForAssetDetails: InspectionFiles[] = [
  {
    fileId: '175902',
    name: 'demo1.jpg',
    fileUUID: 'b0da8c03-07f2-452f-a587-18c6570e67bd',
    originalFileName: 'demo1.jpg',
    originalPath: 'assetInspection/61088/demo1.jpg-1680852713990.jpg',
    legacyId: 0,
    isImageFile: true,
    inspectionId: '61088',
    showOnReport: false,
    fileDescription: 'test description',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 187755,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'image/png',
    dateCreated: '2023-04-07T01:31:56.3269779+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 0,
  },
  {
    fileId: '175903',
    name: 'demo2.jpg',
    fileUUID: '984c3f24-8a2c-4277-b5bd-21643bf7b9fe',
    originalFileName: 'demo2.jpg',
    originalPath: 'assetInspection/61088/demo2.jpg-1680852713852.jpeg',
    legacyId: 0,
    isImageFile: true,
    inspectionId: '61088',
    showOnReport: true,
    fileDescription: '',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 71705,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'image/jpeg',
    dateCreated: '2023-04-07T01:31:57.2768522+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 1,
  },
  {
    fileId: '175904',
    name: 'demo3.jpg',
    fileUUID: 'b0da8c03-07f2-452f-a587-18c6570e67bc',
    originalFileName: 'demo3.jpg',
    originalPath: 'assetInspection/61088/demo3.jpg-1680852713990.jpg',
    legacyId: 0,
    isImageFile: true,
    inspectionId: '61088',
    showOnReport: true,
    fileDescription: '',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 187755,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'image/jpeg',
    dateCreated: '2023-04-07T01:31:56.3269779+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 2,
  },
  {
    fileId: '175905',
    name: 'demo4.pdf',
    fileUUID: 'b0da8c03-07f2-452f-a587-18c6570e67bz',
    originalFileName: 'demo4.pdf',
    originalPath: 'assetInspection/61088/demo4.pdf-1680852713990.pdf',
    legacyId: 0,
    isImageFile: false,
    inspectionId: '61088',
    showOnReport: true,
    fileDescription: '',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 187755,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'application/pdf',
    dateCreated: '2023-04-07T01:31:56.3269779+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 2,
  },
  {
    fileId: '175906',
    name: 'demo5.mp4',
    fileUUID: 'b0da8c03-07f2-452f-a587-18c6575e67bz',
    originalFileName: 'demo5.mp4',
    originalPath: 'assetInspection/61088/demo5.mp4-1680852713990.mp4',
    legacyId: 0,
    isImageFile: false,
    inspectionId: '61088',
    showOnReport: true,
    fileDescription: '',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 187755,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'video/mov',
    dateCreated: '2023-04-07T01:31:56.3269779+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 2,
  },
  {
    fileId: '175907',
    name: 'demo6.docx',
    fileUUID: 'b0ea8b03-07f2-452f-a587-18c6575e67bz',
    originalFileName: 'demo6.docx',
    originalPath: 'assetInspection/61088/demo6.docx-1680852713990.docx',
    legacyId: 0,
    isImageFile: false,
    inspectionId: '61088',
    showOnReport: true,
    fileDescription: '',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 187755,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'application/msword',
    dateCreated: '2023-04-07T01:31:56.3269779+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 2,
  },
  {
    fileId: '175908',
    name: 'demo7.xlsx',
    fileUUID: 'b0ea8b53-07f2-452f-a587-18c6575e67bz',
    originalFileName: 'demo7.xlsx',
    originalPath: 'assetInspection/61088/demo7.xlsx-1680852713990.xlsx',
    legacyId: 0,
    isImageFile: false,
    inspectionId: '61088',
    showOnReport: true,
    fileDescription: '',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 187755,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'text/csv',
    dateCreated: '2023-04-07T01:31:56.3269779+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 2,
  },
  {
    fileId: '175909',
    name: 'demo8.txt',
    fileUUID: 'b0ea8b53-07f2-452f-a584-18c6575e67bz',
    originalFileName: 'demo8.txt',
    originalPath: 'assetInspection/61088/demo8.txt-1680852713990.txt',
    legacyId: 0,
    isImageFile: false,
    inspectionId: '61088',
    showOnReport: true,
    fileDescription: '',
    drawingType: 11,
    fileCategory: 8,
    pcsId: '61088',
    fkAimsfileTblSp: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    sizeMb: 187755,
    allowSpaccess: true,
    siteId: 2,
    disciplineId: 3,
    userCreated: 'jest user',
    userModified: '',
    extension: 'text/plain',
    dateCreated: '2023-04-07T01:31:56.3269779+00:00',
    dateModified: '2023-04-14T05:24:03.3722804+00:00',
    isDelete: 'False',
    fkAssetInspectionTask: 20791,
    fkInspectorField: 496,
    fkInspectorLead: 496,
    fileSortOrder: 2,
  },
];

export const mockTreeViewForAssetDetails: AssetsByAreaHeirachy[] = [
  {
    id: 1,
    name: 'Surface',
    type: '1',
    isActive: true,
    floorLevel: 0,
    siteId: 2,
    disciplineId: 2,
    trafficSafety: 0,
    areaPcsId: '',
    dateModified: '2023-04-14T07:56:59.2813411+00:00',
    children: [
      {
        id: 8385,
        name: '03-29 (Dispatch)',
        type: '11',
        isActive: true,
        floorLevel: 0,
        siteId: 2,
        disciplineId: 2,
        trafficSafety: 4,
        areaPcsId: '02',
        dateModified: '2023-04-14T07:57:00.3591998+00:00',
        children: [
          {
            id: 8386,
            name: 'test line',
            type: '12',
            isActive: true,
            siteId: 2,
            trafficSafety: 4,
            areaPcsId: '02-57-05-7',
            dateModified: '2023-04-14T07:57:00.3591998+00:00',
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Underground',
    type: '2',
    isActive: true,
    floorLevel: 0,
    siteId: 2,
    disciplineId: 2,
    trafficSafety: 0,
    areaPcsId: '',
    dateModified: '2023-04-14T07:56:59.2813568+00:00',
    children: [
      {
        id: 7143,
        name: 'BBP (Battery Bank Platform)',
        type: '21',
        isActive: true,
        floorLevel: 0,
        siteId: 2,
        disciplineId: 2,
        trafficSafety: 4,
        areaPcsId: 'BBP',
        dateModified: '2023-04-14T07:57:00.4796646+00:00',
        children: [],
      },
    ],
  },
];

export const mockAllEnvironmentVariables = {
  data: {
    allEnvironmentConditions: [
      {
        pkEnvironmentConditionCategory: 2,
        name: 'Corrosion',
        abbrv: 'Corro',
        isActive: true,
        siteLayer: null,
        dateCreated: '2016-07-15T09:42:31.025-06:00',
        description: '',
        environmentCondition: [
          {
            pkEnvironmentCondition: 3,
            name: 'Non-corrosive',
          },
          {
            pkEnvironmentCondition: 4,
            name: 'Corrosive',
          },
        ],
      },
      {
        pkEnvironmentConditionCategory: 3,
        name: 'Humidity',
        abbrv: 'Humid',
        isActive: true,
        siteLayer: null,
        dateCreated: '2016-07-15T09:42:31.041-06:00',
        description: '',
        environmentCondition: [
          {
            pkEnvironmentCondition: 5,
            name: 'Dry',
          },
          {
            pkEnvironmentCondition: 6,
            name: 'Wet (Dusty)',
          },
          {
            pkEnvironmentCondition: 9,
            name: 'Wet (Clean)',
          },
        ],
      },
      {
        pkEnvironmentConditionCategory: 4,
        name: 'Temperature',
        abbrv: 'Temp',
        isActive: true,
        siteLayer: null,
        dateCreated: '2016-07-15T09:42:31.041-06:00',
        description: '',
        environmentCondition: [
          {
            pkEnvironmentCondition: 7,
            name: 'Cold',
          },
          {
            pkEnvironmentCondition: 8,
            name: 'Hot',
          },
        ],
      },
      {
        pkEnvironmentConditionCategory: 5,
        name: 'Floor Movement',
        abbrv: 'Floor',
        isActive: true,
        siteLayer: 'Underground',
        dateCreated: '2017-12-08T15:33:33.999-06:00',
        description: '',
        environmentCondition: [
          {
            pkEnvironmentCondition: 10,
            name: 'Accelerated',
          },
          {
            pkEnvironmentCondition: 11,
            name: 'Normal',
          },
        ],
      },
      {
        pkEnvironmentConditionCategory: 6,
        name: 'Back Movement',
        abbrv: 'Back',
        isActive: true,
        siteLayer: 'Underground',
        dateCreated: '2017-12-08T15:33:34.124-06:00',
        description: '',
        environmentCondition: [
          {
            pkEnvironmentCondition: 12,
            name: 'Accelerated',
          },
          {
            pkEnvironmentCondition: 13,
            name: 'Normal',
          },
        ],
      },
      {
        pkEnvironmentConditionCategory: 7,
        name: 'Side Wall(s) Movement',
        abbrv: 'SideWall',
        isActive: true,
        siteLayer: 'Underground',
        dateCreated: '2017-12-08T15:33:34.124-06:00',
        description: '',
        environmentCondition: [
          {
            pkEnvironmentCondition: 14,
            name: 'Accelerated',
          },
          {
            pkEnvironmentCondition: 15,
            name: 'Normal',
          },
        ],
      },
      {
        pkEnvironmentConditionCategory: 8,
        name: 'Water Make',
        abbrv: 'Watermake',
        isActive: true,
        siteLayer: 'Underground',
        dateCreated: '2022-08-09T07:43:36.143Z',
        description: null,
        environmentCondition: [
          {
            pkEnvironmentCondition: 16,
            name: 'None',
          },
          {
            pkEnvironmentCondition: 17,
            name: 'Light',
          },
          {
            pkEnvironmentCondition: 19,
            name: 'Heavy',
          },
        ],
      },
    ],
  },
};

export const mockChildAreaDetails = {
  data: {
    areaDetails: {
      areaId: 8385,
      area: {
        name: 'child name',
        pkArea: 8385,
        fkParentArea: 8334,
        fkAreaType: 3,
        fkSite: 2,
        legacyArea: 1770,
        legacyParentArea: 1672,
        siteLayer: 1,
        isActive: true,
        pcsId: '03-29',
        northGridLine: 1,
        southGridLine: 2,
        eastGridLine: 3,
        westGridLine: 4,
        upperGridLine: 5,
        lowerGridLine: 6,
        modifiedBy: 'jest user',
        dateCreated: '2016-08-04T11:03:14.556-06:00',
        dateModified: '2023-04-14T04:20:52.559Z',
        fileArea: [
          {
            pkFileArea: 30048,
            fkArea: 8385,
            fkFileAims: 175931,
            fkDrawingType: 11,
            name: 'jest1.jpg',
            site: 2,
            discipline: 3,
            legacyId: 0,
            createdBy: 'jest user',
          },
        ],
        areaEnvironmentCondition: [
          {
            pkAreaEnvironmentCondition: 23960,
            fkArea: 8385,
            fkEnvironmentCondition: 7,
            name: 'temperature',
            comment:
              'Excel import. Date of assessment is unknown (dates are derived from when the data was imported)',

            dateAssessed: '2016-08-04T11:03:14.556-06:00',
            dateCreated: '2016-08-04T11:03:14.556-06:00',
            dateModified: '2023-04-14T04:20:52.565Z',

            legacyArea: 1770,
            siteId: 2,
            disciplineId: 3,
          },
          {
            pkAreaEnvironmentCondition: 23961,
            fkArea: 8385,
            fkEnvironmentCondition: 6,
            name: 'humidity',
            comment:
              'Excel import. Date of assessment is unknown (dates are derived from when the data was imported)',
            dateAssessed: '2016-08-04T11:03:14.556-06:00',
            dateCreated: '2016-08-04T11:03:14.556-06:00',
            dateModified: '2023-04-14T04:20:52.568Z',
            legacyArea: 1770,
            siteId: 2,
            disciplineId: 3,
          },
          {
            pkAreaEnvironmentCondition: 23962,
            fkArea: 8385,
            fkEnvironmentCondition: 4,
            name: 'corrosion',
            comment:
              'Excel import. Date of assessment is unknown (dates are derived from when the data was imported)',
            dateAssessed: '2016-08-04T11:03:14.556-06:00',
            dateCreated: '2016-08-04T11:03:14.556-06:00',
            dateModified: '2023-04-14T04:20:52.568Z',
            legacyArea: 1770,
            siteId: 2,
            disciplineId: 3,
          },
        ],
        areaRiskResult: [
          {
            pkAreaRiskResult: 8385,
            fkAreaRiskCategoryRankType: 4,
            fkRiskAssessmentCategory: 3,
            isActive: true,
            comment: 'Excel import',
            dateAssessed: '2023-04-14T04:20:52.763Z',
            dateCreated: '2023-04-14T04:20:52.763Z',
          },
        ],
      },
      historyAreaRiskResult: [
        {
          areaId: 8385,
          fkAreaRiskCategoryRankType: 4,
          category: 'SOC Operations Downtime',
          areaRiskCategoryRankTypeName: 'SevSafteyHigh',
          dateAssessed: '2023-04-14T04:20:52.763Z',
          fkRiskAssessmentCategory: 3,
          comment: 'Excel import',
          riskAssessmentCategoryName: 'Baseline Assessment',
          riskRankName: 'High',
          riskRankValue: 4,
        },
        {
          areaId: 8385,
          fkAreaRiskCategoryRankType: 4,
          category: 'SOC Traffic Safety',
          areaRiskCategoryRankTypeName: 'SevSafteyHigh',
          dateAssessed: '2016-08-04T00:00:00.000-06:00',
          fkRiskAssessmentCategory: 3,
          comment: 'Excel import',
          riskAssessmentCategoryName: 'Baseline Assessment',
          riskRankName: 'High',
          riskRankValue: 4,
        },
      ],
      electHistoryAreaRiskResult: [
        {
          areaId: 35751,
          category: 'Environment Conditions',
          fkAreaRiskCategoryRankType: 7,
          fkRiskAssessmentCategory: 3,
          areaRiskCategoryRankTypeName: 'POFGood',
          riskAssessmentCategoryName: 'Baseline Assessment',
          riskRankName: 'Good',
          riskRankValue: 2,
          comment: 'testing',
        },
      ],
    },
  },
};

export const mockParentAreaDetails = {
  data: {
    areaDetails: {
      areaId: 8334,
      area: {
        name: '03 (White Mill/Thickener)',
        pkArea: 8334,
        fkAreaType: 1,
        fkSite: 2,
        legacyArea: 1672,
        siteLayer: 1,
        isActive: true,
        pcsId: '03',
        modifiedBy: '1',
        dateCreated: '2016-08-04T11:03:14.556-06:00',
        fileArea: [],
        areaEnvironmentCondition: [
          {
            pkAreaEnvironmentCondition: 23666,
            fkArea: 8334,
            fkEnvironmentCondition: 7,
            name: 'temperature',
            comment:
              'Excel import. Date of assessment is unknown (dates are derived from when the data was imported)',
            dateAssessed: '2016-08-04T11:03:14.556-06:00',
            dateCreated: '2016-08-04T11:03:14.556-06:00',
            legacyArea: 1672,
            siteId: 2,
            disciplineId: 3,
          },
          {
            pkAreaEnvironmentCondition: 23667,
            fkArea: 8334,
            fkEnvironmentCondition: 6,
            name: 'humidity',
            comment:
              'Excel import. Date of assessment is unknown (dates are derived from when the data was imported)',
            dateAssessed: '2016-08-04T11:03:14.556-06:00',
            dateCreated: '2016-08-04T11:03:14.556-06:00',
            legacyArea: 1672,
            siteId: 2,
            disciplineId: 3,
          },
          {
            pkAreaEnvironmentCondition: 23668,
            fkArea: 8334,
            fkEnvironmentCondition: 4,
            name: 'corrosion',
            comment:
              'Excel import. Date of assessment is unknown (dates are derived from when the data was imported)',
            dateAssessed: '2016-08-04T11:03:14.556-06:00',
            dateCreated: '2016-08-04T11:03:14.556-06:00',
            legacyArea: 1672,
            siteId: 2,
            disciplineId: 3,
          },
        ],
        areaRiskResult: [
          {
            pkAreaRiskResult: 8334,
            fkAreaRiskCategoryRankType: 4,
            fkRiskAssessmentCategory: 3,
            isActive: true,
            comment: 'Excel import',
            legacyArea: 1672,
            site: 2,
            modifiedBy: 'jest user',
            dateAssessed: '2016-08-04T00:00:00.000-06:00',
            dateCreated: '2016-08-04T11:03:14.556-06:00',
            legacyId: 1672,
          },
        ],
      },
      historyAreaRiskResult: [
        {
          areaId: 8334,
          fkAreaRiskCategoryRankType: 4,
          category: 'SOC Traffic Safety',
          areaRiskCategoryRankTypeName: 'SevSafteyHigh',
          dateAssessed: '2016-08-04T00:00:00.000-06:00',
          fkRiskAssessmentCategory: 3,
          comment: 'Excel import',
          riskAssessmentCategoryName: 'Baseline Assessment',
          riskRankName: 'High',
          riskRankValue: 4,
        },
      ],
    },
  },
};

export const mockLineAndSectionProperty = [
  {
    assetId: '2997',
    dateCreated: '2023-04-18T08:41:54.2406103+00:00',
    dateModified: '2023-04-18T08:41:54.4609162+00:00',
    siteId: 2,
    disciplineId: 3,
    assetSection: [
      {
        fromMajorAsset: null,
        toMajorAsset: null,
        temperature: null,
        name: 'SH 1',
        description: 'test',
        fkSectionDefinition: 13,
        assetSectionArea: [
          {
            fkArea: 8386,
            fkAssetSection: 1250,
            pkAssetSectionArea: 3321,
          },
        ],
        assetSectionMetalicPropertyValue: [
          {
            dOd: null,
            sAllowableUnitStress: null,
            pkAssetSectionMetalicPropertyValue: 1178,
            designCorrosionAllowance: null,
            eLongitudeQualityFactor: null,
            pInternalDesignGause: null,
          },
        ],
        assetSectionPropertyValue: [
          {
            pkAssetSectionPropertyValue: 11632,
            value: '3',
            fkAssetSection: 1250,
            fkSectionPropertyDefinition: 1,
          },
          {
            pkAssetSectionPropertyValue: 11633,
            value: '2',
            fkAssetSection: 1250,
            fkSectionPropertyDefinition: 2,
          },
        ],
        sectionCmlattribute: [
          {
            cmlcode: '0010',
            surface: '1',
            access: '',
            active: true,
            alarm: 20,
            fitting: '1',
            id: 1000,
            readingUser: 'jest user 292',
            refMeasurment: '1',
            cubeId: null,
            dateReading: '2023-04-19T07:05:19.930Z',
            sectionCmlattributeValue: [
              {
                at3: null,
                at6: null,
                at9: null,
                at12: null,
                fkSectionCmlattribute: 1000,
                utMeasurement: 1,
                id: 1000,
              },
            ],
          },
        ],
      },
      {
        fromMajorAsset: null,
        toMajorAsset: null,
        temperature: null,
        name: 'CO 1',
        description: 'test 2',
        fkSectionDefinition: 10,
        assetSectionArea: [
          {
            fkArea: 8195,
            fkAssetSection: 1251,
            pkAssetSectionArea: 3322,
          },
        ],
        assetSectionMetalicPropertyValue: [
          {
            dOd: null,
            sAllowableUnitStress: null,
            pkAssetSectionMetalicPropertyValue: 1179,
            designCorrosionAllowance: null,
            eLongitudeQualityFactor: null,
            pInternalDesignGause: null,
          },
        ],
        assetSectionPropertyValue: [
          {
            pkAssetSectionPropertyValue: 11636,
            value: '2',
            fkAssetSection: 1251,
            fkSectionPropertyDefinition: 1,
          },
          {
            pkAssetSectionPropertyValue: 11637,
            value: '5',
            fkAssetSection: 1251,
            fkSectionPropertyDefinition: 2,
          },
        ],
        sectionCmlattribute: [],
      },
    ],
    assetArea: [
      {
        assetId: 2997,
        areaId: 8385,
        pcsId: '02-57-05-7',
        assetName: 'R57445A',
        assetCategory: 61,
        site: 2,
        discipline: 2,
        layer: 1,
        parentAreaId: 7959,
        parentAreaPcsId: '02-57',
        pkAssetArea: 15191,
        areaName: '02-57-05-7',
        namePcsid: '02-57-05-7-(8.4-SCRUB)',
        fkAreaType: 3,
      },
    ],
  },
];

export const mockAssetSectionDefinition = [
  {
    name: 'Cone',
    id: '10',
    active: true,
    dateCreated: '2020-04-19T09:42:31.6818235-06:00',
    dateModified: null,
    dynamicProperties: [
      {
        name: 'Material of Construction',
        id: 1,
        isFieldEditable: true,
        lOV: [
          { value: 2, display: 'Stainless Steel (Gen.)', sort: 0 },
          { value: 3, display: '2205 SS', sort: 0 },
        ],
      },
    ],
  },
  {
    name: 'Shell',
    id: '13',
    active: true,
    dateCreated: '2020-04-19T09:42:31.6818235-06:00',
    dateModified: null,
    dynamicProperties: [
      {
        name: 'Material of Construction',
        id: 1,
        isFieldEditable: true,
        lOV: [
          { value: 2, display: 'Stainless Steel (Gen.)', sort: 0 },
          { value: 3, display: '2205 SS', sort: 0 },
        ],
      },
    ],
  },
];
